import gql from 'graphql-tag';

export default gql`
  mutation updateCourseLearningNote($update: LearningNoteUpdateInput!, $id: String!) {
    # 更新
    updateCourseLearningNote(update: $update, id: $id) {
      id
    }
  }
`;
